import React from 'react'
import BkFlowSocialShare from '../elements/condensed/BkFlowSocialShare'
import BkFlowReservationPropertyCard from '../elements/condensed/BkFlowReservationPropertyCard'
import _ from 'lodash'


if (process.env.REACT_APP_COMPONENT_CONFIRMATION_LAYOUT === 'condensed') {
  require('../../../styles/css/components/confirmation/condensed/bk-flow-confirmation-condensed.css')
}

const BkFlowConfirmationCondensed = (props) => {
  const {
    configData,
    dsp2TransactionData,
    hotelLabels,
    isTaxInclusiveProperty,
    reservations,
    policiesModalEvent,
    policiesModalVisible,
    reservationWarnings,
    socialMenuEvent,
    socialMenuVisible,
  } = props

  let renderPropertyCards = []
  const dsp2PaymentStatus = _.get(dsp2TransactionData, 'pspTransactionData.status', null)
  let isPendingBooking = reservationWarnings && reservationWarnings === 'Payment Status: PENDING' && dsp2PaymentStatus !== 'OK' ? true : false

  for (const resKey in reservations) {
    const reservation = reservations[resKey]

    renderPropertyCards.push(
      <BkFlowReservationPropertyCard
        configData={configData}
        hotelLabels={hotelLabels}
        isTaxInclusiveProperty={isTaxInclusiveProperty}
        key={'property-card-' + resKey}
        policiesModalEvent={policiesModalEvent}
        policiesModalVisible={policiesModalVisible}
        reservation={reservation}
      />
    )
  }

  return (
    <div className="bk-flow-confirmation__details condensed">
      <div className="bk-flow-confirmation__header">
        <div className="u-container u-container--sm">
          <div className="bk-flow-confirmation__header-content">
            <div className="bk-flow-confirmation__header-titles">
              <h2>{hotelLabels.thankYou ? hotelLabels.thankYou : 'Thank You'}</h2>
              <h4 className="bk-flow-confirmation__header-subtitle">
                {isPendingBooking ?
                  hotelLabels.bookingConfirmedPaymentPendingTitle ? hotelLabels.bookingConfirmedPaymentPendingTitle : 'Your booking request has been received.'
                :
                  hotelLabels.yourBookingSuccessful ? hotelLabels.yourBookingSuccessful : 'Your Booking Was Successful.'
                }
              </h4>
            </div>
            <p className="bk-flow-confirmation__header-email">
              {isPendingBooking ?
                hotelLabels.bookingConfirmedPaymentPendingContent ? hotelLabels.bookingConfirmedPaymentPendingContent : 'Your reservation is being processed and will be confirmed once payment has been authorized. An email will be sent to you shortly with more information.'
              :
                hotelLabels.confirmationEmailMessage ? hotelLabels.confirmationEmailMessage : 'We have sent you an email confirmation with all the details of your stay.'
              }
            </p>
          </div>

          <div className="bk-flow-confirmation__header-actions">
            <BkFlowSocialShare
              hotelLabels={hotelLabels}
              socialMenuEvent={socialMenuEvent}
              socialMenuVisible={socialMenuVisible}
            />
            <button
              className="confirmation-action btn btn-secondary"
              onClick={() => window.print()}
            >
              <i className="material-icons">print</i>
              {hotelLabels.viewPrintReceipt ? hotelLabels.viewPrintReceipt : 'View and Print Receipt'}
            </button>
          </div>
        </div>
      </div>

      {!_.isEmpty(renderPropertyCards) &&
        <div className="bk-flow-confirmation__reservation-property-cards u-container u-container--sm">
          {renderPropertyCards}
        </div>
      }
    </div>
  )
}

export default BkFlowConfirmationCondensed



// WEBPACK FOOTER //
// ./src/components/confirmation/layouts/BkFlowConfirmationCondensed.js